const overlay = document.getElementById("overlay_header");
const targetElement = document.getElementById("enable_overlay");
const cartNotification = document.querySelector(".cart-notification");

const config1 = { attributes: true, attributeFilter: ["open"] };
const observer1 = new MutationObserver(callback1);

function callback1(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === "attributes" && mutation.attributeName === "open") {
      const resultsValue = targetElement.getAttribute("open");
      overlay.style.display = resultsValue === "true" ? "block" : "none";
    }
  }
}

const config2 = { attributes: true, attributeFilter: ["class"] };
const observer2 = new MutationObserver(callback2);

function callback2(mutationsList) {
  mutationsList.forEach((mutation) => {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      overlay.style.display = cartNotification.classList.contains("active")
        ? "block"
        : "none";
    }
  });
}

observer1.observe(targetElement, config1);
observer2.observe(cartNotification, config2);

const flktyInstances = {};
const tabContents = document.querySelectorAll(".tab-content");

function showTab(tabId) {
  tabContents.forEach((tabContent) => {
    tabContent.classList.remove("active");
  });

  const selectedTab = document.getElementById(tabId);
  if (selectedTab) {
    selectedTab.classList.add("active");
    const flkty = flktyInstances[selectedTab.id];
    if (flkty) {
      flkty.resize();
    }
  }

  const tabButtons = document.querySelectorAll(".tab-button");
  tabButtons.forEach((tabButton) => {
    tabButton.classList.remove("active");
  });

  const clickedTabButton = document.querySelector(
    `[data-tab-id="${tabId}"]`
  );
  if (clickedTabButton) {
    clickedTabButton.classList.add("active");
  }

  const collectionButtons = document.querySelectorAll(".collectionbutton");
  collectionButtons.forEach((collectionButton) => {
    collectionButton.classList.remove("active");
  });

  const clickedCollectionButton = document.getElementById(
    tabId.replace("tab", "button")
  );
  if (clickedCollectionButton) {
    clickedCollectionButton.classList.add("active");
  }
}

// Initialize Flickity for all tab contents
tabContents.forEach((tabContent) => {
  const flkty = new Flickity(tabContent, {
    cellAlign: "left",
    contain: true,
    wrapAround: true,
  });
  flktyInstances[tabContent.id] = flkty;
});

document.addEventListener("DOMContentLoaded", function () {
  const detailsContents = document.querySelectorAll(
    ".footer-block__details-content"
  );
  const headings = document.querySelectorAll(".footer-block__heading");

  if (detailsContents.length !== headings.length) {
    console.error(
      "Number of headings does not match the number of details contents."
    );
    return;
  }

  headings.forEach((heading) => {
    heading.addEventListener("click", function () {
      const index = this.dataset.index - 1;
      const content = detailsContents[index];
      content.classList.toggle("active");
      content.style.maxHeight = content.classList.contains("active")
        ? content.scrollHeight + "px"
        : "0";
    });
  });
});

document.querySelectorAll(".faq__category").forEach(function (category) {
  category.addEventListener("click", function () {
    document.querySelectorAll(".faq__category").forEach(function (item) {
      item.classList.remove("active");
    });

    this.classList.add("active");

    document.querySelectorAll(".faq__questions").forEach(function (question) {
      question.classList.remove("active");
    });

    const categoryParent = this.getAttribute("data-categoryparent");
    const questions = document.querySelectorAll(
      `.faq__questions[data-category="${categoryParent}"]`
    );

    questions.forEach(function (question) {
      question.classList.add("active");
    });
  });
});

document.querySelectorAll(".faq__question").forEach(function (question) {
  question.addEventListener("click", function () {
    this.parentElement.classList.toggle("open");

    const icon = this.querySelector("h3");
    icon.classList.toggle("icon-chevron-right");
    icon.classList.toggle("icon-chevron-down");
  });
});

// Initialize Flickity for .newsletter-ui-slider
const newsletterSlider = document.querySelector(".newsletter-ui-slider");
if (newsletterSlider) {
  new Flickity(newsletterSlider, {
    cellAlign: "left",
    contain: true,
    autoPlay: 2000,
    watchCSS: true,
  });
}

// Initialize Flickity for .pp-slider
const ppSlider = document.querySelector(".pp-slider");
if (ppSlider) {
  new Flickity(ppSlider, {
    cellAlign: "left",
    contain: true,
    autoPlay: 2000,
  });
}
